import React from "react";
import { Link } from "react-router-dom";
import { Phone, ArrowRight, ShieldCheck, Sparkles, MessageSquare } from "lucide-react";

const ServicesCTA = () => {
  return (
    <section className="py-20 px-4 sm:px-6 lg:px-12 bg-gradient-to-br from-gray-900 via-zinc-900 to-black text-white relative overflow-hidden">
      {/* Background radial glows */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-red-600/20 blur-3xl pointer-events-none" />
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-rose-600/15 blur-3xl pointer-events-none" />

      <div className="max-w-5xl mx-auto relative z-10 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/10 backdrop-blur-md border border-white/15 text-xs font-semibold uppercase tracking-wider text-red-300 mb-6">
          <Sparkles className="w-4 h-4 text-red-400" />
          <span>Need Custom Property Assistance?</span>
        </div>

        <h2 className="text-3xl sm:text-5xl lg:text-6xl font-black tracking-tight leading-tight">
          Ready to Elevate Your <br />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-red-500 via-rose-400 to-amber-300">
            Real Estate Experience?
          </span>
        </h2>

        <p className="mt-6 text-base sm:text-xl text-gray-300 max-w-2xl mx-auto leading-relaxed">
          Speak with our verified real estate advisors today. Whether you need immediate
          tenant management, an urgent rental agreement, or e-Khata processing, we’re just a message away.
        </p>

        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/contact-us"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-3 px-8 py-4 rounded-2xl bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 text-white font-bold text-base shadow-xl shadow-red-600/30 hover:shadow-red-600/50 hover:scale-105 transition-all duration-200"
          >
            <span>Book Free Consultation</span>
            <ArrowRight className="w-5 h-5" />
          </Link>

          <a
            href="https://wa.me/message/MDG2ZSZNG6P6G1"
            target="_blank"
            rel="noopener noreferrer"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-3 px-8 py-4 rounded-2xl bg-[#25D366] hover:bg-[#20C05C] text-white font-bold text-base shadow-xl shadow-green-600/20 hover:scale-105 transition-all duration-200"
          >
            <MessageSquare className="w-5 h-5" />
            <span>Chat on WhatsApp</span>
          </a>

          <a
            href="tel:8088687429"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-3 px-8 py-4 rounded-2xl bg-white/10 hover:bg-white/20 border border-white/20 text-white font-bold text-base transition-all duration-200"
          >
            <Phone className="w-5 h-5" />
            <span>+91 80886 87429</span>
          </a>
        </div>

        <div className="mt-12 flex flex-wrap items-center justify-center gap-6 text-xs sm:text-sm text-gray-400">
          <div className="flex items-center gap-2">
            <ShieldCheck className="w-4 h-4 text-emerald-400" />
            <span>100% RERA & BBMP Compliant</span>
          </div>
          <div className="flex items-center gap-2">
            <ShieldCheck className="w-4 h-4 text-emerald-400" />
            <span>Zero Hidden Charges</span>
          </div>
          <div className="flex items-center gap-2">
            <ShieldCheck className="w-4 h-4 text-emerald-400" />
            <span>Dedicated Property Manager</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesCTA;
